import { EMPTY_STRING } from "../config";

export const arcSecToMin = (sec?: number) => {
  if (sec == null || !Number.isFinite(sec)) return EMPTY_STRING;
  const time = new Date((sec ?? 0) * 1000);
  return time.getMinutes() +' min ' + time.getSeconds() + ' sec';
};